import { BigNumber } from 'bignumber.js'
import createDependableResource from 'utils/zustand/createDependableResource'
import { getCraftsmanContract } from 'utils/contractHelpers'
import { PREDEFINED_VVS_PER_BLOCK, DEFAULT_TOKEN_DECIMAL, BLOCKS_PER_YEAR } from 'config'

interface VvsPerBlock {
  vvsPerBlock: number
  vvsPerYear: number
}

const fetchVvsPerBlock = async (): Promise<VvsPerBlock> => {
  const craftsmanContract = getCraftsmanContract()
  const vvsPerBlock = new BigNumber((await craftsmanContract.vvsPerBlock()).toString())
    .div(DEFAULT_TOKEN_DECIMAL)
    .toNumber()
  return {
    vvsPerBlock,
    vvsPerYear: BLOCKS_PER_YEAR * vvsPerBlock,
  }
}

export const useVvsPerBlock = createDependableResource<VvsPerBlock>({
  initValue: {
    vvsPerBlock: PREDEFINED_VVS_PER_BLOCK,
    vvsPerYear: PREDEFINED_VVS_PER_BLOCK * BLOCKS_PER_YEAR,
  },
  getValue: fetchVvsPerBlock,
  dependResources: [],
  dbgName: 'VvsPerBlock',
})
